import React, { useEffect, useState } from 'react';
import { MailWarning, X } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore.js';

/** FRE-137: soft nag for signed-in users whose email is not verified. Hidden for guests, verified users and offline. */
export const VerifyEmailBanner: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const isGuest = useAuthStore((s) => s.isGuest);
  const token = useAuthStore((s) => s.token);
  const dismissed = useAuthStore((s) => s.verifyBannerDismissed);
  const openVerifyDialog = useAuthStore((s) => s.openVerifyDialog);
  const dismiss = useAuthStore((s) => s.dismissVerifyBanner);
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (isGuest || !token || !user || user.emailVerified !== false || dismissed || !online) return null;

  return (
    <div
      role="status"
      data-testid="verify-email-banner"
      className="mb-4 flex items-center gap-3 rounded-xl border border-warning/30 bg-warning/10 p-3 text-sm"
    >
      <MailWarning className="size-5 shrink-0 text-warning" />
      <span className="min-w-0 flex-1">ایمیل شما هنوز تایید نشده است. برای ارسال تب به بازارچه و ثبت درخواست، آن را تایید کنید.</span>
      <button type="button" className="btn btn-warning btn-sm" onClick={openVerifyDialog} data-testid="verify-email-banner-open">
        تایید ایمیل
      </button>
      <button type="button" className="btn btn-ghost btn-sm btn-square" onClick={dismiss} aria-label="بستن" data-testid="verify-email-banner-dismiss">
        <X className="size-4" />
      </button>
    </div>
  );
};
